export default __webpack_public_path__ + "static/media/erase.608fd6d2.svg";